import {Component} from '@angular/core'

@Component({
    selector: 'menuitem',
    template:""
})

export class MenuItemComponent {
    
}



// WEBPACK FOOTER //
// ./app/insa-report/menuitem.component.ts